module.exports = __webpack_public_path__ + "img/map-blue-24dp.04639516.svg";